module.exports = function getResource(label) {
    let resources = {
        helpful: 'Utile?',
        thanks: 'Merci pour vos commentaires'
    };
    return resources[label];
};
